import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, downloadFile, formatApiErrorDetail } from "../lib/api";
import DropZone from "../components/DropZone";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function PdfSplit() {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  async function onSplit() {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/pdf/split", fd);
      setResult(data);
      toast.success(t("success"));
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
    setBusy(false);
  }

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-12" data-testid="pdf-split-page">
      <Link to="/tools/pdf" className="eyebrow text-zinc-500 hover:text-black">← {t("cta_back")}</Link>
      <h1 className="hero-h2 text-3xl sm:text-5xl mt-2">{t("tool_split")}</h1>
      <p className="text-zinc-500 mt-2">{t("tool_split_desc")}</p>

      <div className="mt-10">
        {!file ? (
          <DropZone accept="application/pdf" onFiles={(fs) => setFile(fs[0])} testId="split-dropzone" />
        ) : (
          <div className="border border-zinc-200 rounded-md p-6 bg-white">
            <div className="hero-h2 text-xl">{file.name}</div>
            <div className="mt-4 flex gap-3">
              <Button onClick={onSplit} disabled={busy}
                className="rounded-sm bg-black text-white hover:bg-zinc-800 h-11" data-testid="split-submit">
                {busy ? t("processing") : `${t("cta_apply")} →`}
              </Button>
              <Button variant="ghost" className="rounded-sm h-11" onClick={() => { setFile(null); setResult(null); }} data-testid="split-clear">
                {t("cta_clear")}
              </Button>
            </div>
          </div>
        )}

        {result && (
          <div className="mt-6 border border-black rounded-md p-6 bg-zinc-50 fade-up" data-testid="split-result">
            <span className="eyebrow">{t("success")}</span>
            <div className="hero-h2 text-xl mt-1">{result.original_filename}</div>
            <div className="mt-4">
              <Button onClick={() => downloadFile(result.id, result.original_filename)}
                className="rounded-sm bg-black text-white hover:bg-zinc-800 h-10" data-testid="split-download">
                ↓ {t("cta_download")} (.zip)
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
